export default __webpack_public_path__ + "static/media/noveg.6ec23641.png";